import { useEffect, useState } from 'react';
import { Search } from 'lucide-react'; 
import CreateAdmins from './CreateAdmins';
import AllAdmins from './AllAdmins';
import SuperAdminSidebar from './SuperAdminSidebar';
import SuperAdminHeader from './SuperAdminHeader';
import '../../styles/styles.css';

const Admin = () => {
  const [activeTab, setActiveTab] = useState('alladmins');
  const [searchQuery, setSearchQuery] = useState('');
  const [refreshKey, setRefreshKey] = useState(0); // State to trigger re-render

  useEffect(() => {
    const interval = setInterval(() => {
      setRefreshKey((prevKey) => prevKey + 1); // Increment the key to trigger re-render
    }, 500000); // Fetch every 5 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  const renderContent = () => {
    switch (activeTab) {
      case 'createadmins':
        return <CreateAdmins searchQuery={searchQuery} />;
      case 'alladmins':
        return <AllAdmins searchQuery={searchQuery} />;
    
      default:
        return <AllAdmins searchQuery={searchQuery} />;
    }
  };

  return (
   <>
   <SuperAdminHeader page="dashboard" />
    <SuperAdminSidebar />
    <div className="dashboard">
      <h1> CRM Super Admin Dashboard</h1>
      <div className="tabs">
        <button className={activeTab === 'createadmins' ? 'active' : ''} onClick={() => setActiveTab('createadmins')}>
          Create Admins
        </button>
        <button className={activeTab === 'alladmins' ? 'active' : ''} onClick={() => setActiveTab('alladmins')}>
         All Admins
        </button>
       
      </div>

      {/* Search Bar with Icon */}
      <div className="search-bar">
        <Search className="search-icon" size={20} />
        <input
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="content">{renderContent()}</div>
    
    </div>

 </>

  );
};

export default Admin;
